import { render, staticRenderFns } from "./GyomuHokoku.vue?vue&type=template&id=630cea0a&scoped=true"
import script from "./GyomuHokoku.vue?vue&type=script&lang=js"
export * from "./GyomuHokoku.vue?vue&type=script&lang=js"
import style0 from "./GyomuHokoku.vue?vue&type=style&index=0&id=630cea0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630cea0a",
  null
  
)

export default component.exports